export default function Footer() {
  return (
    <footer className="vrt-footer">
      <div className="vrt-footer__inner">
        <span>Propulsé par </span>
        <a href="https://jinnove.tech" target="_blank" rel="noopener noreferrer" className="vrt-footer__link">
          Jinnove
        </a>
      </div>
      <style>{`
        .vrt-footer {
          padding: 18px 16px 24px;
          text-align: center;
          font-size: 12px;
          color: var(--vrt-text-muted);
          background: transparent;
        }
        .vrt-footer__inner { opacity: 0.85; }
        .vrt-footer__link {
          color: var(--vrt-navy);
          font-weight: 700;
          text-decoration: none;
          border-bottom: 1px dotted var(--vrt-navy);
        }
        .vrt-footer__link:hover { color: var(--vrt-teal-700); border-bottom-color: var(--vrt-teal-700); }
      `}</style>
    </footer>
  );
}
